<script setup lang="ts">
import { onMounted, provide, ref, watch } from "vue";
import { RouterLink, RouterView } from "vue-router";
import HelloWorld from "./components/HelloWorld.vue";
import Swiper from "./components/Swiper.vue";



const swiperShow = ref(false);

const menuPath = ref('')
const toggleSwiper = (path: string) => {
  console.log(path);
  menuPath.value = path;
  swiperShow.value = !swiperShow.value;
};
watch(menuPath, (newValue:string) => {
  // console.log('接收到的新值:', newValue);
});
const style = ref({
  left: '100px',
  top: '100px',
  transform:'scale(0)',
  opacity:1,
  // width:'0px',
  // height:'0px',
});
// const width =ref('100%');
// const height =ref('100%');
// window.addEventListener('resize', function() {
//     console.log('Window size changed:', window.innerWidth, window.innerHeight);
//     width.value=window.innerWidth;
//     height.value=window.innerHeight;
//     // alert(window.innerWidth)
//     // alert(window.innerHeight)
// })
const  mzsm = ref('Artist’s Impression');
const infoObj = ref({
  GFA:"110",
  index:"01",
  name:"3BD_C1",
});
const setPos = (pos: { l: string; t: string;scale:number,opacity:number,width:number,height:number})=>{
  Object.assign(style.value, {
    left: pos.l + 'px',
    top: pos.t + 'px',
    transform: `scale(${pos.scale})`,
    opacity: pos.opacity,
  });
}
const setCard = (info: { GFA: any; index: any; name: any; })=>{
  console.log(info);
  infoObj.value.GFA = info.GFA;
  infoObj.value.index = info.index;
  infoObj.value.name = info.name;
}
provide('setPos', setPos);
provide('toggleSwiper', toggleSwiper);
provide('setCard', setCard);
provide('menuPath', menuPath);




// 数据和方法
const isSticky = ref(false);

const toggleStickyHeader = () => {
  const header = document.querySelector('.sticky-header');
  const headerHeight = header.offsetHeight;
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

  if (scrollTop >= headerHeight) {
    isSticky.value = true;
  } else {
    isSticky.value = false;
  }
};



// 初始化监听
onMounted(() => {
  // console.log('Window resized:', window.innerWidth, window.innerHeight);
  document.body.addEventListener('touchmove', function(event) {
    event.preventDefault(); // 禁止上下滚动
  }, { passive: false });

  
  // window.addEventListener('resize', function() {
  //   // 窗口大小变化后执行的代码
  //   window.innerHeight
  //   window.innerWidth
  // });

  // const styleObj =
});
</script>

<template>
  <!-- :style="{width:width,height:height}" -->
  <div class="landscape-container" >
    <div class="mbbox" >
      <img src="./assets//qt/Bitmap.png" alt="" srcset="" class="rotate"  />
    </div>
    <div class="swiperBox" v-if="swiperShow">
      <Swiper  :toggleSwiper="toggleSwiper"  :menuPath="menuPath"/>
    </div>
    <HelloWorld />
  </div>
  <div class="mzsm" >
    <div class="mzsmCon">
      {{mzsm}}
    </div>
  </div>
  <Card :style="style" :infoObj="infoObj"  v-if="0"/>
</template>

<style scoped lang="scss">

@media screen and (min-width: 1601px) {
  .mzsm{
    width: 220px;
    height: 60px;
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 10;
    color: #fff;
    display: flex;
    align-items: end;
    justify-content: flex-start;
    zoom: 0.8;
    .mzsmCon{
      line-height: 1.2;
      font-size: 18px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .mzsm{
    width: 220px;
    height: 60px;
    position: absolute;
    bottom: 20px;
    left: 10px;
    z-index: 10;
    color: #fff;
    display: flex;
    align-items: end;
    justify-content: flex-start;
    zoom: 0.8;
    .mzsmCon{
      line-height: 1;
      font-size: 12px;
    }
}
}

.huxing{
  width: 80px;
  line-height: 30px;
  position: absolute;
  top: 30%;
  font-size: 14px;
  left: 10px;
  background: rgba($color: #000000, $alpha: 0.7);
  text-align: center;
  z-index: 7;
  color: #fff;
  border-radius: 6px;

}
.swiperBox {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0;
  left: 0;
  z-index: 11;
}
.landscape-container {
  position: absolute;
  overflow: hidden;
  .mbbox {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(44, 44, 44);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    .rotate {
      width: 300px;
      transform: rotate(-90deg);
    }
  }
}
/* // 竖屏 */
@media screen and (orientation: portrait) {
  .landscape-container {
    width: 100vh; /* 竖屏时的宽度 */
    height: 100vw; /* 竖屏时的高度 */
    top: calc((100vh - 100vw) / 2); /* 居中对齐 */
    left: calc((100vw - 100vh) / 2);
    transform: rotate(90deg); /* 旋转90度 */
    transform-origin: 50% 50%; /* 旋转中心 */
  }
}

/* // 横屏 */
@media screen and (orientation: landscape) {
  .landscape-container {
    width: 100%;
    height: 100%;
    // width: 100vw; /* 横屏时的宽度 */
    // height: 100vh; /* 横屏时的高度 */
    top: 0; /* 居中对齐 */
    left: 0;
    transform: none; /* 无旋转 */
    transform-origin: 50% 50%; /* 旋转中心 */
    overflow: hidden; /* 防止溢出 */
  }
  .mbbox {
    display: none !important; /* 隐藏mbbox元素 */
  }
}



</style>
